import React from "react";
import { useTranslation } from "react-i18next";
import { moreDataServerTypes } from "pages/Dashboards/OnlineDashboard/types";
import { getMoreDataArray } from "./utils";
import { moreDataTypes } from "./types";
import Trend from "../Components/Trend";

type Props = {
  data: moreDataServerTypes;
};

const MoreData = ({ data }: Props) => {
  const { t } = useTranslation();
  const moreData: moreDataTypes[] = getMoreDataArray(data);

  return (
    <div className="more-data-container">
      {moreData.map((dataObj: moreDataTypes) => (
        <div key={`data-${dataObj.text}`} className="more-data-box data-box">
          <div className="inner-border dashed-inner-border">
            <div className="row-container">
              <Trend
                isIncrease={dataObj.trendIsIncrease}
                isPercentage={false}
                amount={dataObj.reportCompleted}
                trendPercent={dataObj.trendPercentageByPeriod}
                periodAverageTitle={t("dailyAverage")}
              />
              {dataObj.icon}
            </div>
            <p className="more-data-title">{dataObj.text}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MoreData;
